import React from 'react';

import { WLSimpleHeader } from '../../design-library';
import PageContext from '../../templates/context/PageContext';

const LandingHeaderAdapter = () => {
  const slug = React.useContext(PageContext);
  return (
    <WLSimpleHeader
      sticky
      action={{
        color: 'red',
        label: 'Get a Quote',
        href: slug || '',
      }}
    />
  );
};

export default LandingHeaderAdapter;
